import { GetStaticProps } from 'next'
import { ReactElement } from 'react'

import { dehydrate, QueryClient } from 'react-query'

import { blogConfig } from 'app/services/Query/blog/blog.query'
import { NextPage } from 'app/types/decalarations/next'
import {
  getArticlesQueryParams,
  getFeaturedArticlesQueryParams
} from 'app/utils/helpers/blog.helpers'

import BlogLayout from '~/components/layouts/BlogLayout'
import MainLayout from '~/components/layouts/MainLayout'
import BlogView from '~/views/Blog/BlogView'

const BlogPage: NextPage = () => <BlogView />

BlogPage.getLayout = (page: ReactElement) => (
  <MainLayout>
    <BlogLayout withoutContainer>{page}</BlogLayout>
  </MainLayout>
)

BlogPage.getMeta = (intl) => ({
  title: intl.formatMessage({
    defaultMessage: 'Immerse yourself in the world of vehicles with Ifind Blog'
  }),
  description: intl.formatMessage({
    defaultMessage:
      'The blog dedicated to cars, auto parts and useful tips prologing the life of your four-wheeled friend!'
  })
})

export const getStaticProps: GetStaticProps = async (context) => {
  const p = context.params?.p as string

  const articleParams = getArticlesQueryParams({ p })
  const featuredParams = getFeaturedArticlesQueryParams()

  try {
    const queryClient = new QueryClient()
    const { getCategories, getTags, getArticles } = blogConfig

    const articlesKey = getArticles.key(articleParams)
    const featuredArticlesKey = getArticles.key(featuredParams)

    await queryClient.prefetchQuery(getCategories.key, getCategories.request)

    await queryClient.prefetchQuery(getTags.key, getTags.request)
    await queryClient.prefetchQuery(featuredArticlesKey, getArticles.request)
    await queryClient.prefetchQuery(articlesKey, getArticles.request)

    return { props: { dehydratedState: dehydrate(queryClient) } }
  } catch (error) {
    return { notFound: true }
  }
}

export default BlogPage
